import * as Localization from "expo-localization";
import React, { useEffect, useMemo, useState } from "react";

type WorkspaceTimeZoneProviderValue = {
  timezone: string;
  setTimezone: (tz: string | null) => any;
};
const defaultTz = Localization.getCalendars()?.[0]?.timeZone ?? "UTC";
const WorkspaceTimeZoneCtx =
  React.createContext<WorkspaceTimeZoneProviderValue>({
    timezone: defaultTz,
    setTimezone: (tz: string | null) => {},
  });

export const WorkspaceTimeZoneProvider = (
  props: React.PropsWithChildren<{
    timezone?: string;
  }>
) => {
  const parrentTz = useWorkspaceTimeZone();
  const providedTz = props.timezone ?? parrentTz ?? defaultTz;

  const [forzedTz, setForzedTz] = useState<null | string>(null);

  const lowercaseTimezone = useMemo(
    () => (forzedTz ?? providedTz).toLowerCase(),
    [forzedTz, providedTz]
  );

  const value = useMemo(
    () => ({ timezone: lowercaseTimezone, setTimezone: setForzedTz }),
    [lowercaseTimezone]
  );
  return (
    <WorkspaceTimeZoneCtx.Provider value={value}>
      {props.children}
    </WorkspaceTimeZoneCtx.Provider>
  );
};

export const useWorkspaceTimeZone = () => {
  return React.useContext(WorkspaceTimeZoneCtx).timezone;
};

const useSetTimeZone = () => {
  return React.useContext(WorkspaceTimeZoneCtx).setTimezone;
};

export function useForceWorkspaceTimeZone(tz: string | null) {
  const setTimezone = useSetTimeZone();
  useEffect(() => {
    setTimezone(tz);
  }, [setTimezone, tz]);
}
